// extracted by mini-css-extract-plugin
module.exports = {"workoutsDiv":"Workouts_workoutsDiv__2XbKX","workoutCardsDiv":"Workouts_workoutCardsDiv__3KbZ5"};